import React, { useState } from 'react';
import RCUIButton from '../../../shared/components/RCUIButton';
import RCUIOverlay from '../../../shared/components/RCUIOverlay';
import FlexCarousel from './FlexCarousel';
import PropertyTypeItem from './PropertyTypeItem';
import { DEFAULT_ITEMS } from '../constants/exploreByPropertyOptions';
import styles from './ExploreByProperty.scss';
import type { Channel } from '../../../shared/model/tsTypes';

type ExploreByPropertyProps = {
  currentChannel: Channel;
};

const ExploreByProperty = ({ currentChannel }: ExploreByPropertyProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const carouselKey = DEFAULT_ITEMS.map((item) => item.id).join('');

  return (
    <div className={styles.container}>
      <div className={styles.headerWrapper}>
        <h2 className={styles.title}>Explore by property type</h2>
        <RCUIButton classNames={styles.openModalButton} onClickHandler={() => setIsModalOpen(true)}>
          See all
        </RCUIButton>
      </div>
      <RCUIOverlay
        isOpen={isModalOpen}
        id="exploreByPropertyModal"
        closeButtonClasses={styles.closeButtonClasses}
        overlayClasses={styles.overlayClasses}
        closeFn={() => setIsModalOpen(false)}
        allowScroll
      >
        <h2 className={styles.modalTitle}>Explore by property type</h2>
        <div className={styles.modalItems}>
          {DEFAULT_ITEMS.map((propertyTypeObject) => (
            <PropertyTypeItem
              key={propertyTypeObject.id}
              className={styles.modalItem}
              currentChannel={currentChannel}
              propertyTypeObject={propertyTypeObject}
            />
          ))}
        </div>
      </RCUIOverlay>
      <FlexCarousel
        shiftBy={1}
        key={carouselKey}
        arrowClassName={styles.carouselArrow}
        listClassName={styles.carouselList}
        itemClassName={styles.carouselItem}
      >
        {DEFAULT_ITEMS.map((propertyTypeObject) => (
          <PropertyTypeItem
            key={propertyTypeObject.id}
            currentChannel={currentChannel}
            propertyTypeObject={propertyTypeObject}
            className={styles.carouselLink}
          />
        ))}
      </FlexCarousel>
    </div>
  );
};

export default ExploreByProperty;
